import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { TableLoadingSkeleton } from "src/shared/components/tables/table-loading-skeleton";
import { NoData } from "src/shared/components/tables/no-data";
import { Box } from "@mui/material";
import { ILocation } from "src/types/locations";
import StatusChip from "src/shared/components/status-chip";

const tableHeadText = [
  "Name in English",
  "Name in Arabic",
  "Valet",
  "Self-Parking",
];

const Locations = ({ locations }: { locations: ILocation[] }) => {

  return (
    <Box>
      <Box
        sx={{
          bgcolor: "#1A1A1A",
          boxShadow: "0px 14px 44px 0px rgba(0, 0, 0, 0.35)",
          padding: "10px 30px 20px 30px",
          maxHeight: "500px",
          overflow: "auto",
        }}
      >
        <TableContainer sx={{}}>
          <Table aria-label="simple table">
            <TableHead>
              <TableRow>
                {tableHeadText.map((item) => (
                  <TableCell
                    key={item}
                    sx={{
                      fontWeight: 600,
                      color: "#A1A5B7",
                    }}
                    align={item === "Actions" ? "right" : "left"}
                  >
                    {item}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            {false ? (
              <TableLoadingSkeleton rowsLength={4} cellsLength={2} />
            ) : (
              <TableBody>
                {locations.map((row) => {
                  const hasValetService = !!row.services?.find(
                    (service) => service.type === "valet"
                  );
                  const hasSelfParkingService = !!row.services?.find(
                    (service) => service.type === "selfParking"
                  );
                  return (
                    <TableRow
                      key={row.id}
                      sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                    >
                      <TableCell>{row.nameEn}</TableCell>
                      <TableCell>{row.nameAr}</TableCell>
                      <TableCell>
                        <StatusChip
                          color={hasValetService ? "success" : "warning"}
                          label={hasValetService ? "ACTIVE" : "INACTIVE"}
                        />
                      </TableCell>
                      <TableCell>
                        <StatusChip
                          label={hasSelfParkingService ? "ACTIVE" : "INACTIVE"}
                          color={hasSelfParkingService ? "success" : "warning"}
                        />
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            )}
          </Table>
          {locations.length === 0 && <NoData subtitle="" />}
        </TableContainer>
      </Box>
    </Box>
  );
};

export default Locations;
